import { useContext } from 'react'
import { HomeStoreContext } from './HomeStoreProvider.manager'
const useHomeStoreManager = () => useContext(HomeStoreContext)
export default useHomeStoreManager
